namespace Gamification.Gamification {
    export interface AttivazioneForm {
        NewPassword: Serenity.PasswordEditor;
        ConfirmPassword: Serenity.PasswordEditor;
    }

    export class AttivazioneForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Attivazione';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AttivazioneForm.init)  {
                AttivazioneForm.init = true;

                var s = Serenity;
                var w0 = s.PasswordEditor;

                Q.initFormType(AttivazioneForm, [
                    'NewPassword', w0,
                    'ConfirmPassword', w0
                ]);
            }
        }
    }
}
